<template lang="pug">
.doSINGLECHOICE
  .cont  {{cont.stem}}
  .hint {{cont.hint}}
  button(v-model="item.option",v-for='(v,index) in JSON.parse(cont.metas)',
    @click='fun_click(index)',:class="{'active':item.option[index]}")  {{v}}
</template>

<script>
export default {
  props: ["cont", "HistoryData"],
  data() {
    return {
      optionList: ["A", "B", "C", "D", "E", "F", "G", "I", "H"],
      Completed: sessionStorage.getItem("Completed") === "true",
      item: {
        option: []
      },
      id: false
    };
  },
  methods: {
    fun_click(index) {
      if (this.Completed) {
        return;
      }
      if (this.cont.isShow) {
        return;
      }
      if (!this.item.option[index]) {
        this.item.option[index] = true;
      } else {
        this.item.option[index] = false;
      }
      this.$forceUpdate();
    }
  },
  created() {
    if (this.cont.isShow) {
      const i = JSON.parse(this.cont.answer);
      i.forEach(res => {
        this.item.option[res] = true;
      });
    }
    if (this.HistoryData) {
      this.item.option = JSON.parse(this.HistoryData.questionAnswer);
      this.id = this.HistoryData.id;
    }
  }
};
</script>

<style lang="stylus" scoped>
.doSINGLECHOICE
  width 100%
  .cont
    margin-bottom 10px
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 20px
  .hint
    margin-bottom 8px
    color #7b7272
  button
    height 32px
    background rgba(248, 249, 250, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    outline none
    padding 5px
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
    margin 4px
  .active
    background rgba(56, 133, 225, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    line-height 18px
</style>
